/// <reference path="../Service/Service.ts" />
/// <reference path="../Controller/HTML/AppMenu.ts" />
namespace HA.Core.HTML.Service {
    import MenuTag = HA.Core.Controller.HTML.AppMenu;
    import HAService = HA.Core.Service.Service;

    export class HtmlService extends HAService {

        public static uuidv4() {

            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c: string) => {
                const r = Math.random() * 16 | 0;
                const v = c === "x" ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        public static createHtml(data: Map<any, any>, service?: () => void) {
            const t = data.get("t") || "";
            switch (t) {
                case "m":
                    data.set("services", service);
                    return HtmlService.createMenuApp(data);
                case "pa-rlp":
                    return new ResultListPage(data);
                case "pa":
                    return new Page(data);
                default:
                    return HtmlService.createContainer(data);
            }
        }

        public static createFormItem(data: Map<any, any>) {
            const t = data.get("ft") || "";
            switch (t) {
                case "mslct" :
                case "slct" :
                    return new HA.Core.HTML.Form.Select(data);
                case "txt" :
                    data.set("textarea", 1);
                case "txtl" :
                    return new HA.Core.HTML.Form.Text(data);
                case "mtxt" :
                    return new HA.Core.HTML.Form.MultiText(data);
                case "fs" :
                    return new HA.Core.HTML.Form.HAFile(data);
                case "mm" :
                    return new HA.Core.HTML.Form.MultiMedia(data);
                case "btn" :
                    return new HA.Core.HTML.Form.Button(data);
                default:
                    break;
            }
        }

        public static createByType(data: Map<any, any>, main: Tag, translation?: any) {
            const t = data.get("t");
            let tag: List | any = null;
            try {
                switch (t) {
                    case "t1":
                    case "t2":
                    case "t3":
                    case "t4":
                        tag = new Span(data);
                        tag.addClass(t);
                        break;
                    case "tf":
                        tag = new Span(data);
                        tag.addClass("tf");
                        break;
                    case "h1":
                    case "h2":
                    case "h3":
                    case "h4":
                        tag = new Heading(data);
                        break;
                    case "img":
                    case "media":
                        const src: string = main.translate(data.get("src"), translation);
                        if (src) {
                            data.set("src", src);
                        }
                        main.appendChild(new Img(data));
                        break;
                    case "cfc" :
                        main.appendChild(new CFlexContainer(data));
                        break;
                    case "fc" :
                        main.appendChild(new FlexContainer(data));
                        break;
                    case "div" :
                        main.appendChild(new Div(data));
                        break;
                    case "a" :
                        main.appendChild(new Anchor(data));
                        break;
                    case "ai" :
                        return getAppService().processAction(data.get("d"));
                    case "span" :
                        main.appendChild(new Span(data));
                        break;
                    case "p" :
                        main.appendChild(new P(data));
                        break;
                    case "pn" :
                        main.appendChild(new Pane(data));
                        break;
                    case "ref" :
                        main.appendChild(new Reference(data));
                        break;
                    case "formi" :
                        main.appendChild(HtmlService.createFormItem(data));
                        break;
                    case "form" :
                        const form = new HA.Core.HTML.Form.Form(data);
                        form.setAttribute("i", 1);
                        const d2 = new Map();
                        d2.set("tag", form);
                        new HA.Core.Controller.Form.FormController(d2);
                        main.appendChild(form);

                        break;
                    case "inputp" :
                    case "inpute" :
                    case "input" :
                        tag = new Form.Input(data);
                        if (t === "inputp") {
                            tag.setAttribute("type", "password");
                        } else if (t === "inpute") {
                            tag.setAttribute("type", "email");
                        }

                        main.appendChild(tag);
                        break;
                    case "textarea" :
                        main.appendChild(new HA.Core.HTML.Form.Textarea(data));
                        break;
                    case "submit" :
                        tag = new Form.Input(data);
                        tag.setAttribute("type", "submit");
                        main.appendChild(tag);
                        break;
                    case "b" :
                        main.appendChild(new B(data));
                        break;
                    case "i" :
                        main.appendChild(new I(data));
                        break;
                    case "t" :
                        main.appendChild(new Tag(data));
                        break;
                    case "nav" :
                        main.appendChild(new HA.Core.HTML.Navigation.Navigation(data));
                        break;
                    case "dyn":
                        main.appendChild(new Dynamic(data));
                        break;
                    case "mod":
                        main.appendChild(new Module(data));
                        break;
                    case "cite":
                        main.appendChild(new Cite(data));
                        break;
                    case "section":
                        main.appendChild(new Section(data));
                        break;
                    case "table":
                        main.appendChild(new Table(data));
                        break;
                    case "l":
                    case "list":
                        main.appendChild(new List(data));
                        break;
                    case "uimg":
                        main.appendChild(new UImg(data));
                        break;
                    case "win":
                        main.appendChild(new Window(data));
                        break;
                    case "pa":
                        main.appendChild(new Page(data));
                        break;
                    case "carousel":
                        main.appendChild(new Carousel(data));
                        break;
                    case "slider":
                        main.appendChild(new Slider(data));
                        break;
                    case "pa-rlp":
                        main.appendChild(new ResultListPage(data));
                        break;
                    case "rl":
                        main.appendChild(new Div(data));
                        break;
                    case "mp":
                        main.appendChild(new HA.Core.HTML.MenuPane(data));
                        break;
                    case "map":
                        main.appendChild(new HA.Core.HTML.GMap(data));
                        break;
                    case "gal":
                        main.appendChild(new HA.Core.HTML.Media.Gallery(data));
                        break;
                    case "youtube":
                        tag = new Div();
                        tag.appendChild(new Youtube(data));
                        tag.addClass("youtubeContainer");
                        main.appendChild(tag);
                        break;
                    case "twitter":
                        tag = new Div();
                        tag.appendChild(new Twitter(data));
                        tag.addClass("twitterContainer");
                        main.appendChild(tag);
                        break;
                    case "code":
                        main.appendChild(new Code(data));
                        break;
                    case "action":
                        new Action(data);
                        break;
                    default:
                        //log2(["ERR-unknown-tag", t, toObj(data), data, main]);
                        break;
                }
            } catch (e) {
                console.error(e)
                log2(data);
            }
            if (tag) {
                main.appendChild(tag);
            }
        }

        public static createMenuApp(data: Map<any, any>) {
            return new MenuTag(data);
        }

        public static createContainer(data: Map<any, any>) {
            return new Container(data);
        }

    }
}
